
import React from 'react';
import { Dialog, DialogTrigger } from "@/components/ui/dialog";

interface DoctorActionButtonsProps {
  onCreateSampleRecords: () => void;
  isCreateSampleDisabled?: boolean;
}

const DoctorActionButtons: React.FC<DoctorActionButtonsProps> = ({
  onCreateSampleRecords,
  isCreateSampleDisabled
}) => {
  // Return an empty fragment since we're removing all buttons
  return <></>;
};

export default DoctorActionButtons;

